(function () {
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function parseTags(value) {
    return value ? value.split(",").map(function (tag) { return tag.trim(); }).filter(Boolean) : [];
  }

  function postJson(url, data) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    }).then(function (res) { return res.json(); });
  }

  function hasAllTags(need, have) {
    return parseTags(need).every(function (tag) { return have.indexOf(tag) !== -1; });
  }

  function bindRoot(root) {
    if (!root || root.getAttribute("data-asub-bound") === "1") return;
    root.setAttribute("data-asub-bound", "1");

    var form = root.querySelector("[data-asub-form]");
    var emailInput = root.querySelector("[data-asub-email]");
    var submitButton = root.querySelector("[data-asub-submit]");
    if (!form || !emailInput || !submitButton) return;

    var submitLabel = submitButton.querySelector("[data-asub-submit-label]");
    var loader = submitButton.querySelector("[data-asub-loader]");
    var successEl = root.querySelector("[data-asub-success]");
    var errorEl = root.querySelector("[data-asub-error]");
    var companyId = root.getAttribute("data-company-id") || "";
    var listIds = (root.getAttribute("data-list-id") || "").split(",").map(function (id) {
      return id.trim();
    }).filter(Boolean);
    var customSource = root.getAttribute("data-custom-source") || "V3 Anniversary Subscript";
    var tags = root.getAttribute("data-tags") || "";
    var defaultError = root.getAttribute("data-error") || "";
    var alreadyMsg = root.getAttribute("data-already") || "You have already subscribed.";
    var gaEventName = root.getAttribute("data-ga-event") || "";
    var adminBase = window.adminBaseUrl || "admin.awolvision.com";

    function hideMessages() {
      if (successEl) successEl.classList.remove("is-visible");
      if (errorEl) {
        errorEl.textContent = "";
        errorEl.classList.remove("is-visible");
      }
    }

    function setLoading(on) {
      submitButton.disabled = on;
      if (submitLabel) submitLabel.hidden = on;
      if (loader) loader.hidden = !on;
    }

    function showError(message) {
      setLoading(false);
      hideMessages();
      if (!errorEl) return;
      errorEl.textContent = message || defaultError;
      errorEl.classList.add("is-visible");
    }

    function showSuccess() {
      setLoading(false);
      hideMessages();
      emailInput.value = "";
      if (successEl) successEl.classList.add("is-visible");
    }

    function subscribeKlaviyo(email) {
      return Promise.all(listIds.map(function (targetListId) {
        return fetch("https://a.klaviyo.com/client/subscriptions?company_id=" + companyId, {
          method: "POST",
          headers: {
            accept: "application/vnd.api+json",
            revision: "2025-07-15",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: { email: email, properties: { tags: parseTags(tags) } }
                  }
                },
                custom_source: customSource
              },
              relationships: { list: { data: { type: "list", id: targetListId } } }
            }
          })
        }).catch(function (err) {
          console.error("V3 anniversary Klaviyo failed:", targetListId, err);
        });
      }));
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var email = emailInput.value.trim();
      if (!email) return showError("Email is required.");
      if (!EMAIL_RE.test(email)) return showError("Email is invalid.");
      if (!companyId || !listIds.length) return showError(defaultError);

      hideMessages();
      setLoading(true);
      var payload = { email: email, tags: parseTags(tags) };
      var checkUrl = "https://" + adminBase + "/prod-api/email/getShopifyCustomerAwolUs";
      var saveUrl = "https://" + adminBase + "/prod-api/email/createOrUpdateShopifyCustomerAwolUs";

      postJson(checkUrl, payload).then(function (isSubscribed) {
        var nodes = isSubscribed && isSubscribed.data && isSubscribed.data.data &&
          isSubscribed.data.data.customers ? isSubscribed.data.data.customers.nodes : null;
        if (nodes && nodes.length && nodes[0].tags && hasAllTags(tags, nodes[0].tags)) {
          showError(alreadyMsg);
          return null;
        }
        if (!isSubscribed || isSubscribed.code !== 200) {
          showError("You clicked too fast, please try again later.");
          return null;
        }
        return postJson(saveUrl, payload);
      }).then(function (createResult) {
        if (!createResult) return;
        var pack = createResult.data && createResult.data.data;
        var record = pack && (pack.customerCreate || pack.customerUpdate);
        if (!(record && record.customer && record.customer.id)) {
          showError(defaultError);
          return;
        }
        showSuccess();
        subscribeKlaviyo(email).catch(function (err) {
          console.error("V3 anniversary Klaviyo failed:", err);
        });
        if (typeof window.gtag === "function" && gaEventName) {
          window.gtag("event", gaEventName, {
            value: email,
            page_url: window.location.href,
            items: [{ email: email }]
          });
        }
      }).catch(function (err) {
        console.error("V3 anniversary subscribe failed:", err);
        showError(defaultError);
      });
    });

    emailInput.addEventListener("input", hideMessages);
  }

  document.querySelectorAll("[data-v3-asub]").forEach(bindRoot);

  // 页面上可能同时存在 banner / anniversary 两处 script 标签；只注册一次 editor 监听
  if (!window.__v3AnniversaryAsubListener) {
    window.__v3AnniversaryAsubListener = true;
    document.addEventListener("shopify:section:load", function (event) {
      var root = event.target.querySelector("[data-v3-asub]");
      if (!root) return;
      root.removeAttribute("data-asub-bound");
      bindRoot(root);
    });
  }
})();
